function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.026 4.125c3.23 0 5.849 2.608 5.849 5.901 0 1.686-.871 3.617-2.206 5.48a23.127 23.127 0 01-3.655 3.962 21.962 21.962 0 01-3.656-3.942c-1.351-1.887-2.233-3.843-2.233-5.5a5.865 5.865 0 015.901-5.901z",
  stroke: "currentColor",
  strokeWidth: 2.25,
  fill: "none"
});

function SvgWaypoint(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaypoint);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsbD0ibm9uZSI+PHBhdGggZD0iTTEyLjAyNjQgNC4xMjVDMTUuMjU2MiA0LjEyNSAxNy44NzUgNi43MzI3NiAxNy44NzUgMTAuMDI2NEMxNy44NzUgMTEuNzExOSAxNy4wMDQgMTMuNjQyOCAxNS42Njg2IDE1LjUwNkMxNC41NjQ3IDE3LjA0NjIgMTMuMjE2MiAxOC40Mzg3IDEyLjAxMzUgMTkuNDY3NUMxMC44MjIyIDE4LjQ3NSA5LjQ3MDc2IDE3LjA3OTcgOC4zNTgwMSAxNS41MjYxQzcuMDA2NzIgMTMuNjM5NCA2LjEyNSAxMS42ODMgNi4xMjUgMTAuMDI2NEM2LjEyNSA2LjczODMgOC43MzgzIDQuMTI1IDEyLjAyNjQgNC4xMjVaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyLjI1Ii8+PC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };